import { EOverlapType, EHeatingType, EGasSupplyType } from '@cian/api-models/offer-card/v1/get-offer-data';

/* istanbul ignore next */
export function getHouseMaterialType(materialType: string): string | null {
  switch (materialType) {
    case 'block':
      return 'Блочный';
    case 'boards':
      return 'Щитовой';
    case 'brick':
      return 'Кирпичный';
    case 'monolith':
      return 'Монолитный';
    case 'monolithBrick':
      return 'Монолитно кирпичный';
    case 'old':
      return 'Старый фонд';
    case 'panel':
      return 'Панельный';
    case 'stalin':
      return 'Сталинский';
    case 'wood':
      return 'Деревянный';
    case 'aerocreteBlock':
      return 'Газобетонный блок';
    case 'foamConcreteBlock':
      return 'Пенобетонный блок';
    case 'gasSilicateBlock':
      return 'Газосиликатный блок';
    case 'wireframe':
      return 'Каркасный';
  }

  return null;
}

/* istanbul ignore next */
export function getParkingType(parkingType: string): string | null {
  switch (parkingType) {
    case 'roof':
      return 'На крыше';
    case 'underground':
      return 'Подземная';
    case 'ground':
      return 'Наземная';
    case 'multilevel':
      return 'Многоуровневая';
    case 'open':
      return 'Открытая';
    case 'spontaneous':
      return 'Спонтанная';
  }

  return null;
}

const overlapTypeMap: { [key in EOverlapType]: string | null } = {
  [EOverlapType.Concrete]: 'Железобетонные',
  [EOverlapType.Mixed]: 'Смешанные',
  [EOverlapType.Other]: null, // Иные (не отображать)
  [EOverlapType.Unknown]: null, // Не известно (не отображать)
  [EOverlapType.Wood]: 'Деревянные',
};

export function getOverlapType(overlapType: EOverlapType): string | null {
  return overlapTypeMap[overlapType] || null;
}

const heatingTypeMap: { [key in EHeatingType]: string | null } = {
  [EHeatingType.Autonomous]: 'Автономное',
  [EHeatingType.AutonomousBoiler]: 'Автономная котельная',
  [EHeatingType.AutonomousGas]: 'Автономное газовое',
  [EHeatingType.Boiler]: 'Котел/Квартирное отопление',
  [EHeatingType.Central]: 'Центральное',
  [EHeatingType.Coal]: 'Центральное угольное',
  [EHeatingType.Diesel]: 'Дизельное',
  [EHeatingType.Electric]: 'Электрическое',
  [EHeatingType.Fireplace]: 'Камин',
  [EHeatingType.Gas]: 'Центральное газовое',
  [EHeatingType.GasWaterHeater]: 'Индивидуальный тепловой пункт',
  [EHeatingType.Has]: 'Есть',
  [EHeatingType.ITP]: 'Индивидуальный тепловой пункт',
  [EHeatingType.None]: null, // Не указано (не отображать)
  [EHeatingType.Other]: null, // Другое (не отображать)
  [EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
  [EHeatingType.Stove]: 'Печь',
  [EHeatingType.Without]: 'Нет',
};

export function getHeatingType(heatingType: EHeatingType): string | null {
  return heatingTypeMap[heatingType] || null;
}

const gasSupplyTypeMap: { [key in EGasSupplyType]: string | null } = {
  [EGasSupplyType.Autonomous]: 'Автономное',
  [EGasSupplyType.Central]: 'Центральное',
  [EGasSupplyType.Unknown]: null, // Не известно (не отображать)
  [EGasSupplyType.Without]: null, // Отсутствует (не отображать)
};

export function getGasSupplyType(gasSupplyType: EGasSupplyType): string | null {
  return gasSupplyTypeMap[gasSupplyType] || null;
}

export function getHasLabel(value: boolean | null) {
  if (value === null) {
    return null;
  }

  return value ? 'Есть' : 'Нет';
}
